export const COLORS = {
  MenuButtonColor: "#049fdb",
  MenuButtonHoverColor: "#0047ba",
  MenuTitleColor: "#049fdb",
  WhiteColor: "#ffffff",
  MenuButtonHoverBackground: "#f2f2f2",
  PageTitleFirstColor: "#0047ba",
  PageTitleSecondColor: "#00a0df",
  TextColor: "#7f8487",
  ContentTitleColor: "#0047ba",
  ContentSubTitleColor: "#049fdb",
  ContentTextBodyColor: "#898d90",
};
